export const ROUTES = {
    main: '/',
    order: '/order',
    success: '/success',
};
export const DEV_WL_PATH = '/wl';
